//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
// import TagManager from 'react-gtm-module';

//components
import ProdutosLista from '../childrens/produtosLista/.mixins/ProdutosLista';
import Alerta from "../../../../../util/snackbars/.mixins/";

//controllers
import Produtos_controller from '../../../../../../controllers/produtos';

export default class Produtos extends Component {

    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.inputRef = React.createRef();

        this.state = {
            title: 'Devoluções',
            itens: [],
            itensTable: [],
            columns: [],
            isLoading: true,
        }

        this.loadData = this.loadData.bind(this);
        this.setState = this.setState.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.loadData(this, null);
    }

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:produtos',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-produtos',
        //     }
        // });
    }

    async loadData(props, filters) {
        
        const cookies = new Cookies();
        var json = JSON.parse(await Produtos_controller.getProdutos(cookies.get('User-Token'),filters));
        if (json.status) {

            var colunas = [
                'Nome',
                'Descrição'
            ];

            //prepara dados para tabela
            var arrayItens = [];
            json.itens.forEach(element => {
                arrayItens.push([
                    element.nome,
                    element.descricao,
                ]);
            });

            props.setState({
                itens:colunas,
                itensTable:arrayItens,
                isLoading: false,
                columns: colunas
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:produtos',
            //       eventAction: 'callback',
            //       eventLabel: `sucesso:lista-produtos`,
            //     }
            // });

        } else {
            const erroString = 'Erro ao carregar dados de produtos!';
            props.child.current.retorno(erroString,'error');

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:produtos',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${erroString}`,
            //     }
            // });
        }

    }

    render() {
        return (
            <div>
                <ProdutosLista {...this}/>
                <Alerta ref={this.child}/>
            </div>
        );
    }

}